import { render, staticRenderFns } from "./PasswordAuthInput.vue?vue&type=template&id=873cb124&"
import script from "./PasswordAuthInput.vue?vue&type=script&lang=js&"
export * from "./PasswordAuthInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports